import Vue from 'vue'
import Router from 'vue-router'
// import _import from './_import.js'
// const _import = require('./_import.js')
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    // component: _import(resolve, 'home')
    component: resolve => require(['@/views/home.vue'], resolve)
  },
  {
    path: '/endCity',
    name: 'endCity',
    // component: _import(resolve, 'endCity')
    component: resolve => require(['@/views/endCity.vue'], resolve)
  },
  {
    path: '/login',
    name: 'login',
    // component: _import(resolve, 'login')
    component: resolve => require(['@/views/login.vue'], resolve)
  },
  {
    path: '/sendOd',
    name: 'sendOd',
    // component: _import(resolve, 'sendOd'),
    component: resolve => require(['@/views/sendOd.vue'], resolve),
    meta: { requireAuth: true }
  },
  {
    path: '/odState',
    name: 'odState',
    // component: _import(resolve, 'odState'),
    component: resolve => require(['@/views/odState.vue'], resolve),
    meta: { requireAuth: true }
  },
  {
    path: '/coupons',
    name: 'coupons',
    // component: _import(resolve, 'coupons'),
    component: resolve => require(['@/views/coupons.vue'], resolve),
    meta: { requireAuth: true }
  },
  {
    path: '/notWX',
    name: 'notWX',
    // component: _import(resolve, 'notWX')
    component: resolve => require(['@/views/notWX.vue'], resolve)
  },
  {
    path: '/fault',
    name: 'fault',
    // component: _import(resolve, 'notWX')
    component: resolve => require(['@/views/fault.vue'], resolve)
  },
  { path: '*', redirect: '/' }
  // { path: '*', component: NotFoundComponent }
]

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js